import { gql } from "@apollo/client";

const getCompanyProductsLite = gql`
  query GetCompanyProducts($companyId: uuid!) {
    product(where: { companyId: { _eq: $companyId } }) {
      id
    }
  }
`;

export default getCompanyProductsLite;
